import { CdkScrollableModule, ScrollingModule } from "@angular/cdk/scrolling";
import { NgModule } from "@angular/core";
import { MapModule } from "~app/common/components/map/map.module";
import { RaskCommonModule } from "~app/common/rask-common.module";
import { ArbetsorderViol3ButtonComponent } from "./components/arbetsorder-viol3-button/arbetsorder-viol3-button.component";
import { BreadcrumbNavigationComponent } from "./components/breadcrumb-navigation/breadcrumb-navigation.component";
import { Viol3AvtalsobjektComponent } from "./components/viol3/viol3-preview/viol3-avtalsobjekt/viol3-avtalsobjekt.component";
import { Viol3KontraktComponent } from "./components/viol3/viol3-preview/viol3-kontrakt/viol3-kontrakt.component";
import { Viol3PreviewComponent } from "./components/viol3/viol3-preview/viol3-preview.component";
import { Viol3PreviewService } from "./components/viol3/viol3-preview/viol3preview.service";
import { ArbetsorderEventStore } from "./services/arbetsorderEventStore.service";
@NgModule({
    imports: [
        RaskCommonModule,
        MapModule,
        CdkScrollableModule,
        ScrollingModule,
        Viol3PreviewComponent,
        Viol3AvtalsobjektComponent,
        Viol3KontraktComponent,
        BreadcrumbNavigationComponent,
        ArbetsorderViol3ButtonComponent
    ],
    exports: [
        ArbetsorderViol3ButtonComponent,
        BreadcrumbNavigationComponent
    ],
    providers: [
        Viol3PreviewService,
        ArbetsorderEventStore
    ]
})
export class SharedModule { }
